import { ModelFactory } from "@shared/factories/model.factory";
import { MissingCompanyStakeholderKycDocumentType} from "@generated/graphql";
import {
  MissingCompanyStakeholderKycDocument
} from "@modules/company/models/missing-company-stakeholder-kyc-document.model";

export class MissingCompanyStakeholderKycDocumentFactory extends ModelFactory<MissingCompanyStakeholderKycDocumentType, MissingCompanyStakeholderKycDocument> {
  create (state: MissingCompanyStakeholderKycDocumentType): MissingCompanyStakeholderKycDocument {
   return new MissingCompanyStakeholderKycDocument(state)
  }

  fake (): MissingCompanyStakeholderKycDocument {
    throw new Error('This method is not implemented')
  }
}

export const missingCompanyStakeholderKycDocumentFactory = new MissingCompanyStakeholderKycDocumentFactory()
